import moment from 'moment';

const whattype = (param) => {
  if (Number.isNaN(param)) {
    return 'NaN';
  } if (param === null) {
    return 'null';
  }

  return typeof param;
};

class Console {
  constructor(options) {
    this.style = {
      boolean: 'color: #f44336; font-weight: bold;',
      NaN: 'color: #f99157;',
      null: 'color: #d73a49; font-weight: bold;',
      number: 'color: #6f42c1;',
      string: 'color: #454545;',
      undefined: 'color: #d73a49; font-weight: bold;',

      system: 'color: #7E7E7E; font-weight: bold;',
      name: 'color: #000000; font-weight: bold; text-transform: uppercase;',
    };

    this.codes = [{
      string: '#p',
      style: 'color: #7E7E7E; font-weight: bold; padding-right: 2px;',
    }, {
      string: '#a',
      style: 'color: #03A9F4; font-weight: bold; padding-right: 35px;',
    }, {
      string: '#n',
      style: 'color: #4CAF50; font-weight: bold; padding-right: 2px;',
    }];

    this.defaults = {
      dev: process.env.NODE_ENV === 'development',
      name: 'console',
    };

    this.options = Object.assign({}, this.defaults, options);
  }

  group(title, callback) {
    if (!this.options.dev) return false;
    const string = `%c${this.options.name} %c${title} %c@ ${moment().format('H:mm:ss')}`;
    const style = [this.style.system, this.style.name, this.style.system];

    window.console.groupCollapsed(string, ...style);
    callback();
    window.console.groupEnd();
    return true;
  }

  info(title, ...args) {
    if (!this.options.dev) return false;
    const params = [...args];
    const item = this.codes.find(e => e.string === title.substr(0, 2));

    if (typeof title === 'string' && item) {
      const string = title.replace(item.string, '');
      params.unshift(`%c${string.trim()}`, item.style);
    } else {
      params.unshift(`%c${title}`, this.style.string);
    }

    window.console.log(...params);
    return true;
  }

  log(...args) {
    if (!this.options.dev) return false;
    const commands = [`%c${this.options.name}`];
    const styles = [this.style.system];
    const params = [];

    for (let i = 0; i < args.length; i += 1) {
      const elem = args[i];
      const type = whattype(elem);
      if (this.style[type]) {
        commands.push(`%c${elem}`);
        styles.push(this.style[type]);
      } else {
        params.push(elem);
      }
    }

    if (commands.length) {
      params.unshift(commands.join(' '), ...styles);
    }

    window.console.log(...params);
    return true;
  }
}

export default Console;
